import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'Complete your purchase',
  description: 'One secure payment of $27 USD. All major cards accepted worldwide. Takes less than 60 seconds.'
}, {
  icon: '📥',
  number: '02',
  title: 'Download instantly',
  description: 'You receive all 9 PDF files immediately. No waiting. No apps. No subscriptions. Open on any device.'
}, {
  icon: '🖨️',
  number: '03',
  title: 'Print and teach',
  description: 'Print what you need and use it with your very next class. More structure. More engagement. Less prep time. Starting Monday.'
}];
export function HowItWorks() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-122" data-mp="gs0drqnh9y8e">
      <div className="mx-auto max-w-5xl" data-id="element-123" data-mp="14im8yhcdvo0z">
        <div className="mx-auto max-w-2xl text-center" data-id="element-124" data-mp="14hkvk67wapg3">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-125" data-mp="19ae4z7eb6lyi">
            How it works
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-126" data-mp="2rm7k35t0vxhp">
            Simple. Instant. Ready for Monday.
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-127" data-mp="31bhc6lnv9g5t">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-128" data-mp="2wk8zngr8peof" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-129" data-mp="2wjg1332fpvhd">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-cobalt/30 bg-white text-3xl" data-id="element-130" data-mp="3fb8s4rxy16mg">
                  {step.icon}
                </span>
                <span className="mt-4 font-serif-display text-2xl font-bold text-cobalt" data-id="element-131" data-mp="1py5d0o31xlpz">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-ink" data-id="element-132" data-mp="3l08ocblav1hc">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink/70" data-id="element-133" data-mp="3py1w392943jq">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-cobalt/30 md:hidden" aria-hidden="true" data-id="element-134" data-mp="2u470j2kzwxm" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}